import { render, staticRenderFns } from "./caigouTable.vue?vue&type=template&id=df9d3d7e&scoped=true&"
import script from "./caigouTable.vue?vue&type=script&lang=js&"
export * from "./caigouTable.vue?vue&type=script&lang=js&"
import style1 from "./caigouTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9d3d7e",
  null
  
)

export default component.exports